import * as React from "react";

;
export const ChevronRightSmll = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="#100722" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.94 12L8.47 6.53l1.06-1.06L16.06 12l-6.53 6.53-1.06-1.06L13.94 12z" /></svg>;